import React from "react";
import { Link } from "react-router-dom";
import CTA from "../components/cta";
function TermsCondition()
{
    return(
      <>
  <section
    className="flat-title-page mrg-0 brdgm boder-r-0 "
    style={{
      backgroundImage:
        "url(https://www.nvrealestate.ae/images/img/banner-innerpages.jpg)",
      margin: 0
    }}
  >
    <div className="container">
      <div className="breadcrumb-content">
        <h1 className="text-center text-white title">Terms &amp; Conditions</h1>
        <ul className="breadcrumb">
          <li>
            <a href="/" className="text-white">
              Home
            </a>
          </li>
          <li className="text-white">/Terms &amp; Conditions</li>
        </ul>
      </div>
    </div>
  </section>
  <section className="flat-section">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="wow fadeInUp" style={{ visibility: "visible" }}>
          <h3 className="title mt-4">Terms &amp; Conditions – Nova Real Estate</h3>
          <p className="desc"></p>
          <h5 className="mb-15 mt-10">1. General</h5>
          <p className="mb-15">
            a. This document is an electronic record under the Information
            Technology Act, 2000 and related rules. It is generated
            electronically and does not require physical or digital signatures.
            <br />
            b. These Terms of Use are published in compliance with Rule 3(1) of
            the Information Technology (Intermediaries Guidelines) Rules, 2011
            and govern the access and use of www.nvrealestate.ae.
          </p>
          <h5 className="mb-15 mt-10">2. Services</h5>
          <p className="mb-15">
            Nova Real Estate is a professional real estate consultancy offering:
          </p>
          <ul className="list">
            <li>
              Property Search – Research-driven assistance to find properties
              that match client needs.
            </li>
            <li>
              Transaction Support – Help with site visits, pricing, and
              negotiation.
            </li>
            <li>
              Financial &amp; Legal Services – Guidance on mortgages,
              documentation, and administrative processes.
            </li>
            <li>
              Property Portfolio – Residential, commercial, leasing, land,
              affordable housing, and investment projects.
            </li>
            <li>
              Portfolio Management – Structuring and diversification for
              investors, including customized offerings.
            </li>
          </ul>
          <h5 className="mb-15 mt-10">3. Eligibility</h5>
          <p className="mb-15">
            Only persons competent to contract under the Indian Contract Act,
            1872 may use this Website. Users disqualified under any applicable
            law are prohibited from accessing services.
          </p>
          <h5 className="mb-15 mt-10">4. Duration &amp; Termination</h5>
          <ul className="list">
            <li>
              These Terms remain in effect as long as the User continues to
              access or use the Website, or until all transactions are
              completed.
            </li>
            <li>
              Certain clauses (e.g., Indemnity, Intellectual Property, Dispute
              Resolution) survive termination.
            </li>
            <li>
              The Company may suspend or terminate access at its sole
              discretion, without prior notice, for violation of these Terms.
            </li>
          </ul>
          <h5 className="mb-15 mt-10">5. Online Platform</h5>
          <p className="mb-15">
            The Website serves as an online platform providing property
            information, recommendations, and consultancy services.
          </p>
          <h5 className="mb-15 mt-10">6. Communication</h5>
          <p className="mb-15">
            By providing contact details on the Website, the User consents to
            receive calls, messages, and emails from the Company or its
            affiliates. Promotional communication may be opted out of, but
            service-related messages may still be sent.
          </p>
          <h5 className="mb-15 mt-10">7. User Responsibilities</h5>
          <p className="mb-15">Users agree not to:</p>
          <ul className="list">
            <li>
              Copy, reproduce, or misuse Website content without written
              permission.
            </li>
            <li>
              Use unauthorized tools (e.g., bots, scrapers) to access the
              Website.
            </li>
            <li>Upload or post unlawful, offensive, or infringing content.</li>
            <li>Distribute harmful files (e.g., malware, viruses).</li>
            <li>
              Engage in activities that harm Website security or disrupt
              services.
            </li>
            <li>
              Misuse the Website for illegal, fraudulent, or misleading
              purposes.
            </li>
            <li>
              The Company reserves the right to remove content or suspend access
              for violations.
            </li>
          </ul>
          <h5 className="mb-15 mt-10">8. Indemnity &amp; Liability</h5>
          <ul className="list">
            <li>
              Users agree to indemnify Nova Real Estate against all claims,
              damages, or expenses arising from misuse of the Website or breach
              of these Terms.
            </li>
            <li>
              The Company is not responsible for indirect or consequential
              damages, including service interruptions, data loss, or reliance
              on third-party content.
            </li>
          </ul>
          <h5 className="mb-15 mt-10">9. Intellectual Property</h5>
          <p className="mb-15">
            All content, trademarks, logos, and designs on the Website are owned
            by Nova Real Estate or licensed to it. Users may not use or reproduce
            them without prior written consent.
          </p>
          <p className="mb-15">
            Products or projects listed on the Website remain the intellectual
            property of their respective owners.
          </p>
          <h5 className="mb-15 mt-10">10. Disclaimer of Warranties</h5>
          <p className="mb-15">
            The Website and services are provided “as is”, without any express
            or implied warranties. The Company does not guarantee uninterrupted
            service, error-free performance, or virus-free systems. Users access
            the Website at their own risk.
          </p>
          <h5 className="mb-15 mt-10">11. Dispute Resolution</h5>
          <p className="mb-15">
            Disputes shall be resolved through a two-step process:
          </p>
          <p className="mb-15">
            1.Mediation – Parties will attempt amicable resolution within 30
            days.
            <br />
            2.Arbitration – If unresolved, disputes will be referred to a sole
            arbitrator appointed by the Company. Arbitration will be conducted
            in English, with New Delhi, India, as the seat.
            <br />
            These Terms are governed by Indian law, with exclusive jurisdiction
            of the courts in New Delhi.
          </p>
          <h5 className="mb-15 mt-10">12. Notices</h5>
          <p className="mb-15">
            All grievances or disputes must be communicated in writing to the
            Company’s registered office via Registered Post or Speed Post.
          </p>
          <h5 className="mb-15 mt-10">13. Miscellaneous</h5>
          <ul className="list">
            <li>
              Entire Agreement – These Terms and the Privacy Policy form the
              complete agreement between the User and the Company.
            </li>
            <li>
              Waiver – Non-enforcement of any clause does not constitute a
              waiver of rights.
            </li>
            <li>
              Severability – If any clause is deemed invalid, the remaining
              provisions remain enforceable.
            </li>
          </ul>
          <p />
        </div>
      </div>
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default TermsCondition;